import { gql } from '@apollo/client';

// ============================================================================
// QUERIES
// ============================================================================

/**
 * Obtiene el estado actual de la licencia del sistema
 * Incluye datos del comercio desde datos_hotel
 */
export const GET_LICENCIA_SISTEMA = gql`
  query GetLicenciaSistema {
    licenciaSistema {
      codigo_licencia
      tipo_licencia
      tipo_licencia_nombre
      estado_licencia
      fecha_activacion
      fecha_vencimiento
      dias_gracia
      dias_restantes
      en_gracia
      permanente
      nit
      nombre_comercial
      razon_social
      ciudad
      activa
      permitir_acceso
      mensaje
      mostrar_alerta
      tipo_alerta
      modulos
      modulos_version
    }
  }
`;

/**
 * Obtiene la lista de modulos disponibles en el sistema
 * con su estado de habilitacion segun la licencia actual
 */
export const GET_MODULOS_DISPONIBLES = gql`
  query GetModulosDisponibles {
    modulosDisponibles {
      codigo
      nombre
      descripcion
      core
      ruta
      icono
      habilitado
    }
  }
`;

// ============================================================================
// MUTATIONS
// ============================================================================

/**
 * Activa una licencia con los datos obtenidos del gestor
 * Se llama DESPUES de obtener la huella del API del gestor
 */
export const ACTIVAR_LICENCIA = gql`
  mutation ActivarLicencia($input: ActivarLicenciaInput!) {
    activarLicenciaSistema(input: $input) {
      success
      mensaje
      licencia {
        codigo_licencia
        tipo_licencia
        tipo_licencia_nombre
        estado_licencia
        fecha_activacion
        fecha_vencimiento
        dias_gracia
        dias_restantes
        en_gracia
        permanente
        nit
        nombre_comercial
        razon_social
        ciudad
        activa
        permitir_acceso
        mensaje
        mostrar_alerta
        tipo_alerta
        modulos
        modulos_version
      }
    }
  }
`;
